"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CookieBanner = void 0;
const react_1 = __importStar(require("react"));
const react_i18next_1 = require("react-i18next");
const cookieManager_1 = require("../../../../utils/cookieManager");
const Modals_style_1 = require("../Modals.style");
const S = __importStar(require("./CookieBanner.style"));
const CookieBanner = ({ onOpenCookieSettings, }) => {
    const [visible, setVisible] = (0, react_1.useState)(false);
    const { t } = (0, react_i18next_1.useTranslation)();
    (0, react_1.useEffect)(() => {
        if (!cookieManager_1.CookieManager.hasPreferences()) {
            setVisible(true);
        }
    }, []);
    if (!visible)
        return null;
    const handleAllowAll = () => {
        setVisible(false);
        cookieManager_1.CookieManager.enableAll();
    };
    const handleDenyAll = () => {
        setVisible(false);
        cookieManager_1.CookieManager.disableNonNecessary();
    };
    const handleSettingsClick = () => {
        setVisible(false);
        if (onOpenCookieSettings) {
            onOpenCookieSettings();
        }
    };
    return (react_1.default.createElement(S.BannerWrapper, null,
        react_1.default.createElement(S.BannerTitle, null, t("cookieBanner.title")),
        react_1.default.createElement(S.BannerDescription, null, t("cookieBanner.description")),
        react_1.default.createElement(S.BannerActions, null,
            react_1.default.createElement(Modals_style_1.BlueButton, { onClick: handleAllowAll }, t("cookieBanner.allowAll")),
            react_1.default.createElement(S.DenyButton, { onClick: handleDenyAll }, t("cookieBanner.denyAll")),
            react_1.default.createElement(S.SettingsButton, { onClick: handleSettingsClick }, t("cookieBanner.settings")))));
};
exports.CookieBanner = CookieBanner;
